import React from 'react';
import ScrollToTop from '../components/ScrollToTop';


const KidsProgramQuestionnairePage = () => {
    return (
        <>
            <ScrollToTop />
            <div className="coding-for-kids">
                <div className="row justify-content-center align-items-center">
                    <div className='col-sm-12 col-md-8 col-lg-6'>
                    <iframe 
                        src="https://docs.google.com/forms/d/e/1FAIpQLSfUWWmd2yUfQiHwCdLWKPvGOIK6LtSTRRjwerGw3EMZzdox1Q/viewform?embedded=true"
                        className='w-100 google-form'
                        frameBorder="0"
                        marginHeight="0"
                        marginWidth="0"
                        title="WeFlare HTML Course Sign-up Form"
                    >
                    WEFLARE HTML COURSE SIGN-UP
                    </iframe>
                    </div>
                </div>
            </div>  
        </>
    )
}

export default KidsProgramQuestionnairePage